import { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';

import { type useBuyerUrgency_viewer$key } from './__generated__/useBuyerUrgency_viewer.graphql.ts';

const viewerFragment = graphql`
    fragment useBuyerUrgency_viewer on Viewer
    @argumentDefinitions(
        itemId: { type: "String", defaultValue: "" }
        userId: { type: "String", defaultValue: "" }
    ) {
        buyerUrgencyInfo(itemId: $itemId, userId: $userId) {
            totalConversations
        }
    }
`;

export const useBuyerUrgency = ({
    viewer: viewerRef,
}: {
    viewer: useBuyerUrgency_viewer$key;
}): { recentConversationsCount: number; showBuyerUrgencyBanner: boolean } => {
    const viewer = useFragment(viewerFragment, viewerRef);

    const recentConversationsCount = viewer.buyerUrgencyInfo?.totalConversations || 0;

    const results = useMemo(
        () => ({
            recentConversationsCount,
            /**
             * All banner visibility logic should go into dibs-graphql. This allows us to prevent data over-fetching.
             * Data over-fetching handling is too difficult to do on the client side because we're requesting buyerUrgencyInfo in multiple Graphql queries.
             */
            showBuyerUrgencyBanner: !!recentConversationsCount,
        }),
        [recentConversationsCount]
    );

    return results;
};
